import { takeEvery, put } from 'redux-saga/effects';
import {
  checkVersion,
  setVersionRefreshModalIsOpen,
  appNotify
} from 'store/actions';
import React from 'react';
import { Button } from '@material-ui/core';
import { getWithToken } from 'api/network';
import { sendClientLog } from 'services/logService';

export function* versionCheckSaga() {
  yield takeEvery(checkVersion, function* ({ payload: shouldBlock = false }) { 
    try {
      const response = yield getWithToken(`/api/ping/version`);
      const serverVersion = yield response.text();
      let clientVersion = null;
      if (process.env.REACT_APP_BUILD_NUMBER) {
        const arr = process.env.REACT_APP_BUILD_NUMBER.split('.');
        if (arr.length > 3) { // Truncate version to only Major.Minor.Patch (devops redeploys can add a 4th number that causes check to fail)
          arr.length = 3;
        }
        clientVersion = arr.join('.');
      }

      if (clientVersion !== serverVersion) {
        console.log(clientVersion, serverVersion)
        sendClientLog('Info', `Version mismatch - Client version: ${clientVersion}, Server version: ${serverVersion}`);
        if (shouldBlock) {
          yield put(setVersionRefreshModalIsOpen(true));
        } else {
          yield put(appNotify('A new version of ReVUe is available', 'info', { persist: true, disableClose: true, action }));
        }
      }
    }
    catch (error) {
      console.log(error)
    }
  });
}

const action = key => (
  <Button
    variant='outlined'
    size='small'
    color='inherit'
    onClick={() => { window.location.reload(true); }}
  >
    Refresh
  </Button>
);